/**
 * Composable for drag-and-drop and file input handling
 * @param {(file: File) => void} processFileFn - Callback invoked per file
 * @param {{ multiple?: boolean }} options
 */
export function useFileDrop(processFileFn, { multiple = false } = {}) {
  const handleFileChange = event => {
    const files = event.target.files;
    if (!files) return;
    if (multiple) {
      for (const file of files) processFileFn(file);
    } else if (files[0]) {
      processFileFn(files[0]);
    }
  };

  const handleFileDrop = event => {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (!files) return;
    if (multiple) {
      for (const file of files) processFileFn(file);
    } else if (files[0]) {
      processFileFn(files[0]);
    }
  };

  const handleDragOver = event => {
    event.preventDefault();
  };

  return { handleFileChange, handleFileDrop, handleDragOver };
}
